/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import {
  type AnimatedIllustrativeBaseIconProps,
  AnimatedIllustrativeIcon,
} from "../animated-illustrative-icon";
import animationData from "../assets/json/user-checkmark-offblack-animated.json";

export const IllustrativeIconUserCheckmarkOffblackAnimated = (props: AnimatedIllustrativeBaseIconProps) => (
  <AnimatedIllustrativeIcon {...props} json={animationData} />
);

IllustrativeIconUserCheckmarkOffblackAnimated.displayName = "IllustrativeIconUserCheckmarkOffblackAnimated";
